import './Footer.css';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <div className="footer-logo">Servantica</div>
          <p className="muted">AI + communications workspace with Razorpay billing built in.</p>
        </div>
        <div className="footer-links">
          <p className="footer-heading">Product</p>
          <a href="/features">Features</a>
          <a href="/pricing">Pricing</a>
          <a href="/about">About</a>
        </div>
        <div className="footer-links">
          <p className="footer-heading">Access</p>
          <a href="/login">Login</a>
          <a href="/contact">Contact</a>
        </div>
      </div>
      <div className="footer-bottom">© {year} servantica.in. All rights reserved.</div>
    </footer>
  );
};

export default Footer;